/**
 * Injected from index.js after the store exists (same teardown as sign-out, minus navigation).
 * Its RESET_APP is what logs the other tabs out too (services/authSync).
 * Avoids importing the store / authActions from this module (circular deps with api/instance).
 */
let sessionExpiredCleanup = null;

export const setSessionExpiredCleanup = (fn) => {
  sessionExpiredCleanup = typeof fn === "function" ? fn : null;
};

/** Once true, never reset until full page navigation — avoids duplicate modals when `afterClose` used to clear a weaker flag while other 401s were still in flight. */
let sessionExpiredFlowStarted = false;

function defaultStorageOnlyCleanup() {
  sessionStorage.clear();
}

export const handleInvalidToken = () => {
  if (sessionExpiredFlowStarted) return;
  sessionExpiredFlowStarted = true;

  const logOut = () => {
    if (sessionExpiredCleanup) {
      try {
        sessionExpiredCleanup();
      } catch (e) {
        console.error("Session expired cleanup failed:", e);
        defaultStorageOnlyCleanup();
      }
    } else {
      defaultStorageOnlyCleanup();
    }
    window.location.replace("/");
  };

  // antd Modal is loaded on demand: api/instance imports this file, so a static import
  // put Modal + Button styles in the entry chunk just for this rare dialog.
  import("antd/es/modal")
    .then(({ default: Modal }) => {
      Modal.error({
        title: "Session Expired",
        content: "Your session has expired. Please log in again.",
        okText: "I understand, log in again",
        onOk: logOut,
        closable: false,
        maskClosable: false,
        okButtonProps: { style: { zIndex: 1000 } },
        centered: true,
      });
    })
    .catch((e) => {
      // Chunk failed (offline / stale deploy): still end the session rather than leave the user stuck.
      console.error("Session-expired dialog failed to load:", e);
      window.alert("Your session has expired. Please log in again.");
      logOut();
    });
};
